import { useCallback, useEffect, useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';

import LoaderComponent from 'components/authentication/signup/LoaderComponent';
import TableEarned from './TableEarned';
import TableRedeemed from './TableRedeemed';
import { Rewards } from 'lib/api';
import useStyles from './styles';

const REWARD_TYPES = {
    EARNED: 'Earned',
    REDEEMED: 'Redeemed'
};
export const RewardHistory = () => {
    const classes = useStyles();
    const [activeTab, setActiveTab] = useState(0);
    const [earnedRewards, setEarnedRewards] = useState({
        total: 0,
        results: []
    });
    const [earnedPagination, setEarnedPagination] = useState({
        page: 0,
        rowsPerPage: 10
    });
    const [redeemedRewards, setRedeemedRewards] = useState({
        total: 0,
        results: []
    });
    const [redeemedPagination, setRedeemedPagination] = useState({
        page: 0,
        rowsPerPage: 10
    });
    const [isLoading, setIsLoading] = useState(false);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    const fetchEarnedRewards = useCallback(async () => {
        setIsLoading(true);
        try {
            const queryParams = {
                type: REWARD_TYPES.EARNED,
                page: earnedPagination.page,
                limit: earnedPagination.rowsPerPage
            };
            const rewardList = await Rewards.RewardsHistory(queryParams);
            setEarnedRewards(rewardList);
        } catch (error) {
            console.error(error);
        }
        setIsLoading(false);
    }, [earnedPagination.page, earnedPagination.rowsPerPage]);
    const fetchRedeemedRewards = useCallback(async () => {
        setIsLoading(true);
        try {
            const queryParams = {
                type: REWARD_TYPES.REDEEMED,
                page: redeemedPagination.page,
                limit: redeemedPagination.rowsPerPage
            };
            const rewardList = await Rewards.RewardsHistory(queryParams);
            setRedeemedRewards(rewardList);
        } catch (error) {
            console.error(error);
        }
        setIsLoading(false);
    }, [redeemedPagination.page, redeemedPagination.rowsPerPage]);
    useEffect(() => {
        fetchEarnedRewards();
        fetchRedeemedRewards();
    }, [fetchEarnedRewards, fetchRedeemedRewards]);

    return (
        <Box className={classes.pointsRewardsContainer}>
            <Box sx={{ borderBottom: '1px solid #D0D5D9', marginRight: '45px' }}>
                <label className={classes.labelInsideContainer}>
                    Reward History ({earnedRewards.total + redeemedRewards.total})
                </label>
                <Tabs
                    sx={{
                        marginTop: '10px',
                        '& .MuiTabs-indicator': {
                            backgroundColor: '#182D55'
                        },
                        color: '#182D55'
                    }}
                    value={activeTab}
                    onChange={handleTabChange}
                    textColor="inherit">
                    <Tab
                        label={REWARD_TYPES.EARNED}
                        sx={{
                            fontWeight: activeTab === 0 ? 'bold' : 'normal'
                        }}
                    />
                    <Tab
                        label={REWARD_TYPES.REDEEMED}
                        sx={{
                            fontWeight: activeTab === 1 ? 'bold' : 'normal'
                        }}
                    />
                </Tabs>
            </Box>
            {isLoading ? (
                <Box display="flex" flexDirection="row" alignSelf="center" justifyContent="center">
                    <LoaderComponent />
                </Box>
            ) : (
                <>
                    {activeTab === 0 && (
                        <TableEarned rewards={earnedRewards} pagination={earnedPagination} setPagination={setEarnedPagination} />
                    )}
                    {activeTab === 1 && (
                        <TableRedeemed
                            rewards={redeemedRewards}
                            pagination={redeemedPagination}
                            setPagination={setRedeemedPagination}
                        />
                    )}
                </>
            )}
        </Box>
    );
};
